import { render, staticRenderFns } from "./AUserChip.vue?vue&type=template&id=1da943b0&scoped=true&"
import script from "./AUserChip.vue?vue&type=script&lang=ts&"
export * from "./AUserChip.vue?vue&type=script&lang=ts&"
import style0 from "./AUserChip.vue?vue&type=style&index=0&id=1da943b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da943b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VChip,VIcon})
